import React from "react";
import nextId from "react-id-generator";
import { Link, useHistory } from "react-router-dom";
import {
  updatePersonalDetails,
  uploadFile,
  uploadResume,
} from "../../../../APIs/PostAPIS";
import CustomCheckBox from "../../../Common/CustomCheckbox/CustomCheckBox";
import CustomDropdown from "../../../Common/CustomDropdown/CustomDropdown";
import { MainContext } from "../../../Dashboard/DashboardContext/Context";
import Notification from "../../../Portals/Notification/Notification";
import "./personal-details.style.scss";

const phoneRegex = /^(\d){9,12}$/;

export default function PersonalDetails({
  changeRoute,
  currentRoute,
  setNotification,
  notification,
}) {
  const history = useHistory();
  const context = React.useContext(MainContext);
  const [countryCode, setCountryCode] = React.useState("+91");
  const { userDetails, initialChecking } = context;
  const [uploading, setUploading] = React.useState(false);
  const [loading, setLoading] = React.useState(false);
  const [personalDetails, setPersonalDetails] = React.useState({
    candidate_full_name: "",
    candidate_primary_contact_no: "",
    candidate_gender: "",
    candidate_current_location: "",
    candidate_img: "",
    candidate_email: "",
    candidate_id: "",
    user_id: "",
  });

  const clearNotification = () => {
    history.push("/register/qualification");
    let a = setTimeout(() => {
      setNotification({
        status: false,
        title: "",
        moreDetails: "",
      });
      changeRoute();
      setLoading(false);
      clearTimeout(a);
    }, [3000]);
  };
  const updateDetails = async () => {
    try {
      setLoading(true);
      let email = localStorage.getItem("userEmail");
      let ID = localStorage.getItem("userId");
      let temp = {
        ...personalDetails,
        user_id: ID,
        candidate_email: email,
        candidate_primary_contact_no:
          countryCode + "-" + personalDetails.candidate_primary_contact_no,
      };
      let res = await updatePersonalDetails({ ...temp });
      if (!res.data.error) {
        initialChecking();
        setNotification({
          status: true,
          title: res.data.message,
          moreDetails: "",
        });
        clearNotification();
      } else {
      }
    } catch (error) {
      setLoading(false);
    }
  };
  const handleUpload = async (e) => {
    if (e.target.files[0].size > 3000000) {
      setNotification({
        status: true,
        title: "Max size 3MB",
        moreDetails: "",
      });
      return;
    }

    setUploading(true);

    let doc = e.target.files[0];
    const formData = new FormData();
    formData.append("newFile", doc);
    try {
      let res = await uploadResume(formData);
      if (res.data.data) {
        setPersonalDetails({
          ...personalDetails,
          candidate_img: res.data.data.file_link,
        });
      } else {
      }

      setUploading(false);
    } catch (error) {
      setUploading(false);
    }
  };
  React.useEffect(() => {
    currentRoute();
  }, []);
  React.useEffect(() => {
    let num = userDetails?.candidate_primary_contact_no;
    num = userDetails?.candidate_primary_contact_no?.split("-");
    let other = "";
    if (num?.length === 2) {
      setCountryCode(num[0]);
      other = num[1];
    } else {
      setCountryCode("+91");
      other = num?.[0] || "";
    }

    let temp = {
      candidate_full_name: userDetails.candidate_full_name,
      candidate_primary_contact_no: other,
      candidate_gender: userDetails.candidate_gender,
      candidate_current_location: userDetails.candidate_current_location,
      candidate_img: userDetails.candidate_img,
      candidate_email: userDetails.candidate_email,
      candidate_id: userDetails.candidate_id,
      user_id: "",
    };
    setPersonalDetails({ ...temp });
  }, [userDetails]);
  return (
    <form
      onSubmit={(e) => {
        e.preventDefault();
        updateDetails();
      }}
      className="personal-details-main"
    >
      <header className="pdm-header">
        <p>Step 1. Personal Details</p>
      </header>
      <div className="pdm-body">
        <label className="pdmb-upload-wrapper">
          <div className="uploaded-image">
            <img
              src={
                personalDetails.candidate_img ||
                "https://img.icons8.com/color/48/000000/user.png"
              }
            />
          </div>
          <div className="upload-buttons">
            <p>
              <label htmlFor="dp">
                {uploading
                  ? "Uploading..."
                  : personalDetails.candidate_img
                  ? "Uploaded"
                  : "Upload"}
                <input
                  disabled={personalDetails.candidate_img}
                  accept="image/*"
                  id="dp"
                  onChange={(e) => {
                    handleUpload(e);
                    e.target.value = "";
                  }}
                  type="file"
                  className="d-none"
                />
              </label>
              <button
                type="button"
                onClick={() =>
                  setPersonalDetails({ ...personalDetails, candidate_img: "" })
                }
              >
                Remove
              </button>
            </p>
            <p>JPG or PNG. Max size of 3MB</p>
          </div>
        </label>
        <div className="fancy-input-wrapper">
          <span>Full name*</span>
          <input
            placeholder="Thomas James"
            value={personalDetails.candidate_full_name}
            required
          />
        </div>
        <div className="fancy-input-wrapper phone">
          <span>Mobile Number*</span>
          <div className="inner-wrapper">
            {/* <input disabled value={"+91"} type="" /> */}
            <div className="codes">
              <CustomDropdown
                sendClicked={(obj) => setCountryCode(obj.id)}
                selected={countryCode}
                list={codeList}
              />
            </div>
            <input
              onChange={(e) =>
                setPersonalDetails({
                  ...personalDetails,
                  candidate_primary_contact_no: e.target.value,
                })
              }
              type="tel"
              pattern="^(\d){9,12}$"
              value={personalDetails.candidate_primary_contact_no}
              placeholder="000000 00000"
              required
            />
          </div>
        </div>
        <div className="fancy-input-wrapper">
          <span>Current working location*</span>
          <input
            onChange={(e) =>
              setPersonalDetails({
                ...personalDetails,
                candidate_current_location: e.target.value,
              })
            }
            placeholder="Bangalore"
            value={personalDetails.candidate_current_location}
            required
          />
        </div>

        <CustomCheckBox
          handleChange={(obj) =>
            setPersonalDetails({ ...personalDetails, candidate_gender: obj.id })
          }
          list={genderList}
          selected={personalDetails.candidate_gender}
          title="Gender"
        />
      </div>
      <div className="pdm-footer">
        <button
          type="submit"
          disabled={
            loading || !personalDetails.candidate_gender
            // !phoneRegex.test(personalDetails.candidate_primary_contact_no)
          }
        >
          {loading ? "Updating...." : "Update"}
        </button>
      </div>
    </form>
  );
}
const genderList = [
  { keyId: nextId(), name: "Male", id: "male" },
  { keyId: nextId(), name: "Female", id: "female" },
];
const codeList = [
  { keyId: nextId(), name: "+93 ", id: "+93" },
  { keyId: nextId(), name: "+355", id: "+355" },
  { keyId: nextId(), name: "+355", id: "+355" },
  { keyId: nextId(), name: "+374", id: "+374" },
  { keyId: nextId(), name: "+61", id: "+61" },
  { keyId: nextId(), name: "+43", id: "+43" },
  { keyId: nextId(), name: "+880", id: "+880" },
  { keyId: nextId(), name: "+32", id: "+32" },
  { keyId: nextId(), name: "+975", id: "+975	" },
  { keyId: nextId(), name: "+975", id: "+975" },
  { keyId: nextId(), name: "+1", id: "+1" },
  { keyId: nextId(), name: "+86", id: "+86" },
  { keyId: nextId(), name: "+503", id: "+503" },
  { keyId: nextId(), name: "+33", id: "+33" },
  { keyId: nextId(), name: "+49", id: "+49" },
  { keyId: nextId(), name: "+91", id: "+91" },
  { keyId: nextId(), name: "+972", id: "+972" },
  { keyId: nextId(), name: "+81", id: "+81" },
  { keyId: nextId(), name: "+64", id: "+64" },
  { keyId: nextId(), name: "+850", id: "+850" },
  { keyId: nextId(), name: "+7", id: "+7" },
];
